import React from 'react';

import {getUserTitle} from 'app/components/general/avatars/BaseUserAvatar';
import ElapsedTime from 'app/components/general/ElapsedTime';
import {TaskProgressStepFieldType} from 'app/tasks/types';
import {gt} from 'app/utils/i18n';

import type {StepFieldType} from 'sweet-types';

interface Props {
  field: StepFieldType;
  progress?: TaskProgressStepFieldType;
}
export const FieldLastEditStamp = ({progress}: Props): JSX.Element | null =>
  progress != null && progress.updated_at != null ? (
    <div className="text-right">
      <small className="font-italic">
        {gt('Updated by %(userName)s %(elapsedTime)s', {
          userName: <b>{getUserTitle(progress.updated_by)}</b>,
          elapsedTime: <ElapsedTime timestamp={progress.updated_at} />,
        })}
      </small>
    </div>
  ) : null;
